import { TimerT } from "../../features/camera/SelectTimer";

interface Props {
    className: string;
    stroke: string;
    delay?: TimerT;
}

const Timer = ({ className, stroke, delay }: Props) => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {delay === undefined && (
                <>
                    <path
                        d="M10 2H14"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 14L15 11"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 22C16.4183 22 20 18.4183 20 14C20 9.58172 16.4183 6 12 6C7.58172 6 4 9.58172 4 14C4 18.4183 7.58172 22 12 22Z"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            )}
            {delay === 0 && (
                <>
                    <path
                        d="M10 2H14"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4.59999 11C3.99419 12.4562 3.83235 14.059 4.13482 15.607C4.43729 17.1549 5.19058 18.5789 6.29999 19.7C7.42107 20.8094 8.84506 21.5627 10.393 21.8652C11.9409 22.1676 13.5438 22.0058 15 21.4"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7.40002 7.40003C8.95712 6.31969 10.8472 5.82722 12.7335 6.01035C14.6198 6.19349 16.3798 7.04034 17.7 8.40003C19.019 9.72671 19.8313 11.4737 19.9957 13.3372C20.1601 15.2007 19.6663 17.0629 18.6 18.6"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M2 2L22 22"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 12V10"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            )}
            {delay === 5 && (
                <>
                    <path
                        d="M10.1232 17.0696C9.81167 17.0696 9.53161 17.0099 9.28303 16.8906C9.0361 16.7696 8.8389 16.6039 8.69141 16.3935C8.54392 16.183 8.4652 15.9427 8.45526 15.6726H9.20099C9.21922 15.8913 9.31617 16.0711 9.49183 16.212C9.6675 16.3529 9.87796 16.4233 10.1232 16.4233C10.3188 16.4233 10.492 16.3786 10.6428 16.2891C10.7952 16.1979 10.9145 16.0728 11.0007 15.9137C11.0885 15.7546 11.1325 15.5732 11.1325 15.3693C11.1325 15.1622 11.0877 14.9774 10.9982 14.815C10.9087 14.6526 10.7853 14.525 10.6278 14.4322C10.4721 14.3394 10.2931 14.2921 10.0909 14.2905C9.93679 14.2905 9.78184 14.317 9.62607 14.37C9.47029 14.4231 9.34434 14.4927 9.24822 14.5788L8.54474 14.4744L8.83061 11.9091H11.6296V12.5678H9.46946L9.30788 13.9922H9.33771C9.43714 13.8961 9.56889 13.8157 9.73295 13.7511C9.89867 13.6864 10.076 13.6541 10.2649 13.6541C10.5748 13.6541 10.8507 13.7279 11.0927 13.8754C11.3363 14.0228 11.5277 14.2242 11.6669 14.4794C11.8078 14.733 11.8774 15.0246 11.8757 15.3544C11.8774 15.6842 11.8028 15.9783 11.652 16.2369C11.5028 16.4954 11.2957 16.6992 11.0305 16.8484C10.767 16.9959 10.4646 17.0696 10.1232 17.0696ZM15.6547 14.114L14.9811 14.2333C14.9529 14.1471 14.9082 14.0651 14.8469 13.9872C14.7872 13.9093 14.706 13.8455 14.6032 13.7958C14.5005 13.7461 14.3721 13.7212 14.218 13.7212C14.0075 13.7212 13.8318 13.7685 13.691 13.8629C13.5501 13.9557 13.4797 14.0759 13.4797 14.2234C13.4797 14.351 13.5269 14.4537 13.6214 14.5316C13.7158 14.6095 13.8683 14.6733 14.0787 14.723L14.6853 14.8622C15.0366 14.9434 15.2984 15.0685 15.4708 15.2376C15.6431 15.4066 15.7293 15.6262 15.7293 15.8963C15.7293 16.125 15.663 16.3288 15.5305 16.5078C15.3995 16.6851 15.2164 16.8243 14.9811 16.9254C14.7474 17.0265 14.4765 17.0771 14.1682 17.0771C13.7407 17.0771 13.3918 16.9859 13.1217 16.8036C12.8516 16.6197 12.6859 16.3587 12.6246 16.0206L13.343 15.9112C13.3877 16.0985 13.4797 16.2402 13.6189 16.3363C13.7581 16.4308 13.9395 16.478 14.1633 16.478C14.4069 16.478 14.6016 16.4274 14.7474 16.3263C14.8933 16.2236 14.9662 16.0985 14.9662 15.951C14.9662 15.8317 14.9214 15.7314 14.8319 15.6502C14.7441 15.569 14.609 15.5077 14.4268 15.4663L13.7805 15.3246C13.4242 15.2434 13.1607 15.1141 12.99 14.9368C12.8209 14.7595 12.7364 14.5349 12.7364 14.2631C12.7364 14.0378 12.7994 13.8406 12.9253 13.6715C13.0513 13.5025 13.2253 13.3707 13.4474 13.2763C13.6694 13.1802 13.9238 13.1321 14.2105 13.1321C14.6231 13.1321 14.9479 13.2216 15.1849 13.4006C15.4219 13.5779 15.5785 13.8157 15.6547 14.114Z"
                        fill="black"
                        strokeWidth={0}
                    />
                    <path
                        d="M10 2H14"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 22C16.4183 22 20 18.4183 20 14C20 9.58172 16.4183 6 12 6C7.58172 6 4 9.58172 4 14C4 18.4183 7.58172 22 12 22Z"
                        stroke={stroke}
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            )}
            {delay === 10 && (
                <>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            strokeWidth={0}
                            d="M8.63113 11.9091V17H7.86053V12.6797H7.8307L6.61266 13.4751V12.7393L7.8829 11.9091H8.63113ZM11.7806 17.0845C11.3879 17.0829 11.0523 16.9793 10.7739 16.7738C10.4955 16.5683 10.2825 16.2692 10.135 15.8764C9.98754 15.4837 9.9138 15.0105 9.9138 14.457C9.9138 13.9052 9.98754 13.4337 10.135 13.0426C10.2842 12.6515 10.498 12.3532 10.7764 12.1477C11.0564 11.9422 11.3912 11.8395 11.7806 11.8395C12.1701 11.8395 12.504 11.9431 12.7824 12.1502C13.0608 12.3557 13.2738 12.654 13.4213 13.0451C13.5704 13.4345 13.645 13.9052 13.645 14.457C13.645 15.0122 13.5712 15.4862 13.4237 15.8789C13.2762 16.27 13.0633 16.5691 12.7849 16.7763C12.5065 16.9818 12.1717 17.0845 11.7806 17.0845ZM11.7806 16.4208C12.1253 16.4208 12.3946 16.2526 12.5885 15.9162C12.7841 15.5798 12.8818 15.0934 12.8818 14.457C12.8818 14.0344 12.8371 13.6773 12.7476 13.3857C12.6598 13.0923 12.533 12.8703 12.3673 12.7195C12.2032 12.567 12.0077 12.4908 11.7806 12.4908C11.4376 12.4908 11.1683 12.6598 10.9727 12.9979C10.7772 13.3359 10.6786 13.8223 10.6769 14.457C10.6769 14.8813 10.7209 15.2401 10.8087 15.5334C10.8982 15.825 11.0249 16.0463 11.189 16.1971C11.3531 16.3462 11.5503 16.4208 11.7806 16.4208ZM17.3979 14.114L16.7243 14.2333C16.6961 14.1471 16.6513 14.0651 16.59 13.9872C16.5304 13.9093 16.4492 13.8455 16.3464 13.7958C16.2437 13.7461 16.1152 13.7212 15.9611 13.7212C15.7507 13.7212 15.575 13.7685 15.4341 13.8629C15.2933 13.9557 15.2228 14.0759 15.2228 14.2234C15.2228 14.351 15.2701 14.4537 15.3645 14.5316C15.459 14.6095 15.6114 14.6733 15.8219 14.723L16.4284 14.8622C16.7798 14.9434 17.0416 15.0685 17.214 15.2376C17.3863 15.4066 17.4725 15.6262 17.4725 15.8963C17.4725 16.125 17.4062 16.3288 17.2736 16.5078C17.1427 16.6851 16.9596 16.8243 16.7243 16.9254C16.4906 17.0265 16.2196 17.0771 15.9114 17.0771C15.4838 17.0771 15.135 16.9859 14.8649 16.8036C14.5948 16.6197 14.429 16.3587 14.3677 16.0206L15.0861 15.9112C15.1309 16.0985 15.2228 16.2402 15.362 16.3363C15.5012 16.4308 15.6827 16.478 15.9064 16.478C16.15 16.478 16.3448 16.4274 16.4906 16.3263C16.6364 16.2236 16.7093 16.0985 16.7093 15.951C16.7093 15.8317 16.6646 15.7314 16.5751 15.6502C16.4873 15.569 16.3522 15.5077 16.1699 15.4663L15.5236 15.3246C15.1673 15.2434 14.9038 15.1141 14.7331 14.9368C14.5641 14.7595 14.4796 14.5349 14.4796 14.2631C14.4796 14.0378 14.5426 13.8406 14.6685 13.6715C14.7944 13.5025 14.9685 13.3707 15.1905 13.2763C15.4126 13.1802 15.667 13.1321 15.9537 13.1321C16.3663 13.1321 16.6911 13.2216 16.9281 13.4006C17.1651 13.5779 17.3217 13.8157 17.3979 14.114Z"
                            fill="black"
                        />
                        <path
                            d="M10 2H14"
                            stroke={stroke}
                            strokeWidth="1.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M12 22C16.4183 22 20 18.4183 20 14C20 9.58172 16.4183 6 12 6C7.58172 6 4 9.58172 4 14C4 18.4183 7.58172 22 12 22Z"
                            stroke={stroke}
                            strokeWidth="1.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </>
            )}
        </svg>
    );
};

export default Timer;
